module.exports = __webpack_public_path__ + "static/media/build-a-schedule.8e4ce38d.png";